export const themes = ['light', 'dark'] as const;
export type Theme = typeof themes[number];

export const variants = ['primary', 'secondary', 'tertiary'] as const;
export type Variant = typeof variants[number];
